import { DateTime } from 'luxon'

import { SongFeedbackResponseDTO } from '@/core/api/dtos/response/song/songFeedback'
import { SongFeedback } from '@/core/api/entities/song/songFeedback'
import { AccountMapper } from '@/core/api/mappers/account/accountMapper'
import { PlaylistMapper } from '@/core/api/mappers/playlist/playlistMapper'
import { FeedbackTypeMapper } from '@/core/api/mappers/song/feedbackTypeMapper'
import { SongMapper } from '@/core/api/mappers/song/songMapper'
import { UserMapper } from '@/core/api/mappers/userMapper'
import { ZoneMapper } from '@/core/api/mappers/zone/zoneMapper'

export class SongFeedbackMapper {
	static toEntity(data: SongFeedbackResponseDTO): SongFeedback {
		return new SongFeedback({
			songId: data.song_id,
			feedbackTypeId: data.feedback_type_id,
			playlistId: data.playlist_id,
			accountId: data.account_id,
			userId: data.user_id,
			playerId: data.player_id,
			createdAt: DateTime.fromISO(data.created_at),
			feedbackType: data.feedback_type
				? FeedbackTypeMapper.toEntity(data.feedback_type.data)
				: undefined,
			user: data.user ? UserMapper.toEntity(data.user.data) : undefined,
			playlist: data.playlist
				? PlaylistMapper.toEntity(data.playlist.data)
				: undefined,
			song: data.song ? SongMapper.toEntity(data.song.data) : undefined,
			account: data.account
				? AccountMapper.toEntity(data.account.data)
				: undefined,
			player: data.player ? ZoneMapper.toEntity(data.player.data) : undefined,
		})
	}

	static toEntities(data: SongFeedbackResponseDTO[]): SongFeedback[] {
		return data.map((item) => this.toEntity(item))
	}
}
